var _g, _circle, _circle2, _circle3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPgvector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "pgvector \u2014 mark + wordmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 26 L21 16 L30 20",
    stroke: "#7EE7C7",
    strokeWidth: 1.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 19 L33 17 L31 21 Z",
    fill: "#7EE7C7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 26,
    r: 2.8,
    fill: "#6BD7F2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 16,
    r: 3.6,
    fill: "#7EE7C7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 20,
    r: 2.4,
    fill: "#9AD1FF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 41,
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
    fontWeight: 600,
    fontSize: 6.2,
    fill: "#BEEFE8",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "pgvector")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgvector);
export default __webpack_public_path__ + "static/media/pgvector.d662c7b6f450419e0fdefcde632555fd.svg";
export { ForwardRef as ReactComponent };